import React, { useEffect, useMemo, useState } from "react";
import { IdcardOutlined } from "@ant-design/icons";
import { Button } from "antd";
import moment from "moment";
import "./EmployeeDetail.scss";
import EditDetailsModal from "./EditDetailsModal";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getEmployeeDetails } from "../../../assets/api/othres";
import PanelCard from "../../../Pages/DashboardPage/components/PanelCard";

const EMPTY = "—";

const initialsOf = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

const EmployeeDetail = () => {
  const [editOpen, setEditOpen] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const [employeeData, setEmployeeData] = useState(null);
  const { id } = useParams();

  const fetchEmployeeDetails = async () => {
    try {
      const res = await getEmployeeDetails(id, token);
      if (res.status === 200) {
        setEmployeeData(res?.data?.data);
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    fetchEmployeeDetails();
  }, [])

  /* Driven off a list so the conditional rows do not need the nth-child
     border juggling the old three-column table relied on. */
  const details = useMemo(() => {
    if (!employeeData) return [];

    const joined = employeeData.date_of_joining
      ? moment(employeeData.date_of_joining)
      : null;

    const rows = [
      { label: "Role", value: employeeData.role },
      { label: "Email", value: employeeData.email },
      {
        label: "Date of joining",
        value: joined?.isValid() ? joined.format("DD MMM YYYY") : null,
      },
      { label: "Phone no.", value: employeeData.phone },
    ];

    if (
      employeeData.role !== "Supervisor" &&
      employeeData.role !== "Team Lead"
    ) {
      rows.push({ label: "Team lead", value: employeeData.team_lead });
    }

    if (employeeData.role !== "Supervisor") {
      rows.push({
        label: "Supervisor",
        value: employeeData.supervisor?.join(", "),
      });
    }

    rows.push({ label: "City", value: employeeData.city });
    rows.push({ label: "Pin code", value: employeeData.pincode });

    return rows;
  }, [employeeData]);

  return (
    <div className="employeeDetailsPage">
      <PanelCard
        title="Employee Details"
        icon={<IdcardOutlined />}
        accent="brand"
        className="employeeDetailsCard"
        actions={
          <Button className="editBtn" onClick={() => setEditOpen(true)}>
            Edit Details
          </Button>
        }
      >
        <div className="employeeDetailsHeader">
          <div className="avatarInfo">
            {/* Initials rather than an <img src="/default-avatar.png">, which
                does not exist and rendered as a broken image. */}
            <div className="avatar" aria-hidden="true">
              {initialsOf(employeeData?.name) || "NA"}
            </div>
            <div className="userInfo">
              <h3>{employeeData?.name || EMPTY}</h3>
              <p className="userId">{employeeData?.email || EMPTY}</p>
            </div>
          </div>

          {employeeData?.role && (
            <span className="roleChip">{employeeData.role}</span>
          )}
        </div>

        <div className="employeeDetailsTable">
          {details.map(({ label, value }) => (
            <div className="detailItem" key={label}>
              <span className="label">{label}</span>
              <span className={`value ${value ? "" : "is-empty"}`}>
                {value || EMPTY}
              </span>
            </div>
          ))}
        </div>
      </PanelCard>

      <EditDetailsModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        employee={employeeData}
      />
    </div>
  );
};

export default EmployeeDetail;
